import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';
import { useBranding } from '@/lib/branding/BrandingProvider';

export interface NeuraxEmployee {
  id: string;
  user_id: string | null;
  email: string;
  full_name: string | null;
  role: 'admin' | 'member' | 'viewer' | string;
  is_active: boolean;
  invite_status: 'pending' | 'accepted' | string | null;
  created_at: string;
}

async function fetchEmployees(companyId: string): Promise<NeuraxEmployee[]> {
  const { data, error } = await supabase
    .from('b2b_employees')
    .select('id, user_id, email, full_name, role, is_active, invite_status, created_at')
    .eq('b2b_company_id', companyId)
    .eq('is_active', true)
    .order('created_at', { ascending: false });

  if (error) throw new Error(`b2b_employees: ${error.message}`);
  return (data ?? []) as NeuraxEmployee[];
}

export function useEmployees() {
  const { companyId } = useBranding();
  return useQuery({
    queryKey: ['neurax', 'employees', companyId],
    queryFn: () => fetchEmployees(companyId),
    staleTime: 30_000,
  });
}
